/**
 * Dependencies.
 */
import emojiRegex from 'emoji-regex';

/**
 * Trim start and end of string.
 * It also removes multiple spaces in the middle of the string and leaves only one.
 */
const trimString = (value: string) => {
  if (value) {
    value = value.replace(/\s+/g, ' ').trim();
  }

  return value;
};

/**
 * Remove emojis from string.
 * It also trims the string.
 */
const removeEmojis = (value: string) => {
  if (value) {
    const regex = emojiRegex();

    value = value.replace(regex, '');

    value = trimString(value);
  }

  return value;
};

/**
 * Export helpers.
 */
export { removeEmojis, trimString };
